import { render, staticRenderFns } from "./foreignHospitalSumMore.vue?vue&type=template&id=1cdc7c82&scoped=true&"
import script from "./foreignHospitalSumMore.vue?vue&type=script&lang=js&"
export * from "./foreignHospitalSumMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc7c82",
  null
  
)

export default component.exports